export const SalaryData = [
  {
    link: "/salary-slip",
    employeeId: "001",
    name: "Karyawan A",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "001",
    paymentPeriod: "Monthly",
    paymentDate: "01-01-2022",
    paymentStatus: "Paid",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "002",
    name: "Karyawan B",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "002",
    paymentPeriod: "Monthly",
    paymentDate: "10-01-2022",
    paymentStatus: "Paid",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "003",
    name: "Karyawan C",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "003",
    paymentPeriod: "Monthly",
    paymentDate: "25-12-2021",
    paymentStatus: "Pending",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "004",
    name: "Karyawan D",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "004",
    paymentPeriod: "Monthly",
    paymentDate: "31-12-2021",
    paymentStatus: "Paid",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "005",
    name: "Karyawan E",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "005",
    paymentPeriod: "Monthly",
    paymentDate: "31-01-2022",
    paymentStatus: "Pending",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "006",
    name: "Karyawan F",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "006",
    paymentPeriod: "Monthly",
    paymentDate: "01-02-2022",
    paymentStatus: "Pending",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "007",
    name: "Karyawan G",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "007",
    paymentPeriod: "Monthly",
    paymentDate: "20-01-2022",
    paymentStatus: "Paid",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "008",
    name: "Karyawan H",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "008",
    paymentPeriod: "Monthly",
    paymentDate: "30-11-2021",
    paymentStatus: "Paid",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "009",
    name: "Karyawan I",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "009",
    paymentPeriod: "Monthly",
    paymentDate: "01-12-2021",
    paymentStatus: "Paid",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "010",
    name: "Karyawan J",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "010",
    paymentPeriod: "Monthly",
    paymentDate: "01-01-2022",
    paymentStatus: "Pending",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
  {
    link: "/salary-slip",
    employeeId: "011",
    name: "Karyawan K",
    division: "Developer Team",
    jobTitle: "Fullstack Developer",
    paymentId: "011",
    paymentPeriod: "Monthly",
    paymentDate: "01-12-2021",
    paymentStatus: "Paid",
    workDays: "20",
    workHours: "80",
    overtimeHours: "0",
    absence: 0,
    leaveBalance: 10,
    basicSalary: 5000000,
    bpjs: 100000,
    tax: 500000,
    totalDeduction: 600000,
    totalSalary: 4400000,
  },
];
